import uuid from "uuid/v4";
import {
  ADD_TO_CART,
  DECREASE_QUANTITY,
  DECREASE_PRICE,
  DELETE_FROM_CART,
  DELETE_ALL_FROM_CART,
  PRE_REMOVE_ITEM,
  UPDATE_ALL_PRICES
} from "../actions/cartActions";

import { tierCalculator } from "../../helpers/tier-pricing";

const initState = [];

const calculateCost = (priceData, quantity, yItem, name, product) => {
  try {
    const calculateData = {
      quantity,
      P: priceData,
    };
    calculateData[name] = yItem;
    const resultProduct = tierCalculator.calculate(
      product.formula[name],
      calculateData
    );
    return Number.isNaN(resultProduct) ? 0 : resultProduct;
  } catch (error) {
    return 0;
  }
};
const selectCalculation = (decorationType) => {
  if (decorationType === "embroidery") {
    return "stitchCount";
  }
  if (decorationType === "screenPrint") {
    return "numberOfColors";
  }
  if (decorationType === "imprint") {
    return "numberOfColors";
  }
};
const calculateNewTotalFee = (newTotalQty, product) => {
  let totalFee = 0
  if (selectCalculation(product.decorationType) === "numberOfColors") {
    for (let i = 0; i < product.decorations.length; i += 1) {
      totalFee += calculateCost(
        1,
        newTotalQty,
        `Color ${product.decorations[i].colors?.length}`,
        selectCalculation(product.decorationType),
        product
      ) * newTotalQty
    }
    return totalFee
  }
  return (
    calculateCost(
      1,
      newTotalQty,
      1,
      selectCalculation(product.decorationType),
      product
    ) *
    newTotalQty *
    product.decorations.length
  );
};

const cartReducer = (state = initState, action) => {
  
  const cartItems = state,
    product = action.payload;

  if (action.type === ADD_TO_CART) {
      if (cartItems === undefined) {
        return [
          ...cartItems,
          {
            ...product,
            cartItemId: uuid(),
            id: uuid()
          }
        ];
      } else if (
        cartItems !== undefined &&
        (cartItems.selectedProductColor !== product.selectedProductColor ||
          cartItems.selectedProductSize !== product.selectedProductSize)
      ) {
        return [
          ...cartItems,
          {
            ...product,
            cartItemId: uuid(),
            id: uuid()
          }
        ];
      } else {
        return cartItems.map(item =>
          item.cartItemId === cartItems.cartItemId
            ? {
                ...item,
              }
            : item
        );
      }
    }

  if (action.type === DECREASE_QUANTITY) {
    if (product.quantity === 1) {
      const remainingItems = (cartItems, product) =>
        cartItems.filter(
          cartItem => cartItem.cartItemId !== product.cartItemId
        );
      return remainingItems(cartItems, product);
    } else {
      return cartItems.map(item =>
        item.cartItemId === product.cartItemId
          ? { ...item, quantity: item.quantity - 1 }
          : item
      );
    }
  }

  if (action.type === UPDATE_ALL_PRICES) {
    const discountArrays = []
    const discountGroups = []
    const discountGroupsFlat = []
    const productIds = []
    for (let i = 0; i < cartItems?.length; i += 1) {
      let index = product?.items?.findIndex(data => data.data.productData.productId === cartItems[i].productId)
        const productCostS = product.items[i]?.data?.pricingManagement?.productCostS
          ?.enabled
          ? product.items[index]?.data?.pricingManagement?.productCostS
          : product.selectedStore?.data?.pricingManagement?.productCostS;
        const stitchCount = product.items[index]?.data?.pricingManagement?.stitchCount?.enabled
          ? product.items[index]?.data?.pricingManagement?.stitchCount
          : product.selectedStore?.data.pricingManagement?.stitchCount;
        const numberOfColors = product.items[index]?.data?.pricingManagement?.numberOfColors
          ?.enabled
          ? product.items[index]?.data?.pricingManagement?.numberOfColors
          : product.selectedStore?.data?.pricingManagement?.numberOfColors;
         cartItems[i].formula = { stitchCount: stitchCount, productCostS: productCostS, numberOfColors: numberOfColors }
  }
    for (let i = 0; i < cartItems?.length; i += 1) {
      discountArrays.push(cartItems[i].discountId)
      productIds.push(cartItems[i].productId)
    }
    const uniq = [...new Set(discountArrays)]
    for (let i = 0; i < uniq?.length; i += 1) {
      if (cartItems.filter(item => uniq?.[i]?.includes(item.discountId))?.length > 1) {
        const groupIds = []
        const groupIdsFlat = []
      for (let j = 0; j < cartItems.filter(item => uniq[i].includes(item.discountId))?.length; j += 1) {
        groupIds.push({cartId: cartItems.filter(item => uniq[i].includes(item.discountId))[j]?.cartItemId})
        groupIdsFlat.push(cartItems.filter(item => uniq[i].includes(item.discountId))[j]?.cartItemId)
      }
      discountGroups.push(groupIds)
      discountGroupsFlat.push(groupIdsFlat)
    }
    }

     for (let i = 0; i < discountGroups?.length; i += 1) {
      let totalQty = 0
       for (let y = 0; y < discountGroups[i]?.length; y += 1) {
         for (let j = 0; j < cartItems?.length; j += 1) {
           if (cartItems[j].cartItemId === discountGroups[i][y].cartId) {
            totalQty += cartItems[j].totalQuantity
           }
           }
       }
       let newTotalFee = 0
        const getFormula = cartItems.filter(data => discountGroups[i][0].cartId === data.cartItemId)[0]
        newTotalFee = calculateNewTotalFee(totalQty, getFormula)
        for (let u = 0; u < cartItems?.length; u += 1) {
          if (discountGroupsFlat[i].includes(cartItems[u].cartItemId)) {
            cartItems[u].discountedFee = (newTotalFee / totalQty) * cartItems[u].totalQuantity
            cartItems[u].discountedPrice = (cartItems[u].totalPrice - cartItems[u].totalFee) + (cartItems[u].totalQuantity * (newTotalFee / totalQty))
        }
      }
      }
  }

  if (action.type === DECREASE_PRICE) {
    for (let i = 0; i < cartItems?.length; i += 1) {
      if (product.newPrice.cartIds.includes(cartItems[i].cartItemId)) {
        cartItems[i].discountedFee = cartItems[i].totalQuantity * product.newPrice.newExtraFee
        cartItems[i].discountedPrice = (cartItems[i].totalPrice - cartItems[i].totalFee) + (cartItems[i].totalQuantity * product.newPrice.newExtraFee)
      }
      }
  }

  if (action.type === PRE_REMOVE_ITEM) {
    let decoQty = 0
    let newExtraFee = 0
    const calculateCost = (priceData, quantity, yItem, name) => {
      try {
        const calculateData = {
          quantity,
          P: priceData,
        };
        calculateData[name] = yItem;
        const resultProduct = tierCalculator.calculate(
          product.formula[name],
          calculateData
        );
        return Number.isNaN(resultProduct) ? 0 : resultProduct;
      } catch (error) {
        return 0;
      }
    };
    const selectCalculation = (decorationType) => {
      if (decorationType === "embroidery") {
        return "stitchCount";
      }
      if (decorationType === "screenPrint") {
        return "numberOfColors";
      }
      if (decorationType === "imprint") {
        return "numberOfColors";
      }
    };
    const calculateIntPrice = (data, quantity, yItem, calculateName) => {
      return calculateCost(data, quantity, yItem, calculateName);
    };
    const calculateNewTotalFee = (newTotalQty) => {
      let totalFee = 0
      if (selectCalculation(product.decorationType) === "numberOfColors") {
        for (let i = 0; i < product.decorations.length; i += 1) {
          totalFee += calculateCost(
            1,
            newTotalQty,
            `Color ${product.decorations[i].colors?.length}`,
            selectCalculation(product.decorationType)
          ) * newTotalQty
        }
        return totalFee
      }
      return (
        calculateIntPrice(
          1,
          newTotalQty,
          1,
          selectCalculation(product.decorationType)
        ) *
        newTotalQty *
        product.decorations.length
      );
    };
    const items = []
    for (let i = 0; i < cartItems?.length; i += 1) {
      if (cartItems[i].discountId === product.discountId) {
        items.push(cartItems[i].cartItemId)
      }
    }
    const index = items.indexOf(product.cartItemId);
    if (index > -1) { // only splice array when item is found
      items.splice(index, 1); // 2nd parameter means remove one item only
    }
    for (let i = 0; i < cartItems?.length; i += 1) {
      if (items.includes(cartItems[i].cartItemId)) {
      decoQty += cartItems[i].totalQuantity
    }
    }
    newExtraFee = calculateNewTotalFee(decoQty) / decoQty
    for (let i = 0; i < cartItems?.length; i += 1) {
      if (items.length > 1) {
        if (items.includes(cartItems[i].cartItemId)) {
          cartItems[i].discountedFee = cartItems[i].totalQuantity * newExtraFee
          cartItems[i].discountedPrice = (cartItems[i].totalPrice - cartItems[i].totalFee) + (cartItems[i].totalQuantity * newExtraFee)
        }
      } else {
      if (items.includes(cartItems[i].cartItemId)) {
        cartItems[i].discountedFee = 0
        cartItems[i].discountedPrice = 0
      }
    }
    }
  }

  if (action.type === DELETE_FROM_CART) {
    const remainingItems = (cartItems, product) =>
      cartItems.filter(cartItem => cartItem.cartItemId !== product.cartItemId);
    return remainingItems(cartItems, product);
  }

  if (action.type === DELETE_ALL_FROM_CART) {
    return cartItems.filter(item => {
      return false;
    });
  }

  return state;
};

export default cartReducer;